export function EmptyTimeslots({ adjustDate = true }) {
  const message = adjustDate
    ? "Please select another date to see available time slots"
    : "Please adjust your scheduling options to see available time slots";
  return (
    <div
      className={`
        mt-3
        flex flex-col items-center justify-center
        rounded-lg border-2 border-dashed border-gray-300 bg-gray-50
        p-8 text-center
        min-h-80
      `}
    >
      <div className="mb-2">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-1">
        No times available
      </h3>
      <p className="text-sm text-gray-500">{message}</p>
    </div>
  );
}
